import React, { createContext, useContext, useMemo, useState } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  // --- состояния
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [headerTitle, setHeaderTitle] = useState("WHFOF"); // 👈 заголовок меню

  const value = useMemo(() => ({
    // --- state
    searchOpen,
    searchQuery,
    headerTitle,

    // --- actions
    openSearch: () => setSearchOpen(true),
    closeSearch: () => setSearchOpen(false),
    setSearchQuery,
    resetSearch: () => {
      setSearchQuery("");
      setSearchOpen(false);
    },

    // управление заголовком
    setHeaderTitle,
    resetHeaderTitle: () => setHeaderTitle("WHFOF"),
  }), [searchOpen, searchQuery, headerTitle]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be used within a UIProvider");
  return ctx;
}

export default { UIProvider, useUI };
